import React, { Fragment, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Button, Col, Container, Form, FormGroup, Input, Row, Table } from 'reactstrap';
import Breadcrumbs from '../../layout/breadcrumb';
import Loader from '../../layout/loader';

export default function Products() {
  const token = document.cookie.split(`jwt=`).pop().split(';').shift();
  let history = useNavigate();
  const [loading, setLoading] = useState(false);
  const [products, setproducts] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('')

  const fetchData = async () => {
    setLoading(true);
    const request = {
      method: "GET",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "Origin, X-requested-With, Content-Type, Accept",
        'Authorization': 'Bearer ' + token
      }
    }
    try {
      var responce = await fetch("https://lsreport.shls.care/api/products", request, { mode: "cors" });
      if (responce.status === 200) {
        let data = await responce.json();
        setproducts(data);

      } else {
        toast.error(await responce.json());
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.message);
    }
    setLoading(false);
  }

  const filtredList = Array.isArray(products)
    ? searchKeyword
      ? products.filter((product) => {
        const product_name = product.product_name.toLowerCase() || "";
        const product_dci = product.product_dci.toLowerCase() || "";
        const product_form = product.product_form.toLowerCase() || "";
        return product_form.includes(searchKeyword.toLowerCase()) || product_name.includes(searchKeyword.toLowerCase()) || product_dci.includes(searchKeyword.toLowerCase());
      })
      : products
    : [];

  useEffect(() => {
    fetchData();
    window.scrollTo(0, 0)
  }, [])

  return (
    <Fragment>
      <Loader isLoading={loading} />
      <Breadcrumbs parent="Produits" title="Produits" />
      <Container fluid={true} className='pb-4 mb-4'>
        <Row>
          <Col>
            <Button color='dark' onClick={() => history(`/products/add/`)}>
              Ajouter
            </Button>
          </Col>
          <Col md={"3"} lg="6" className='f-right feature-products'>
            <Form onSubmit={(e) => e.preventDefault()}>
              <FormGroup>
                <Input
                  className="form-control"
                  type="text"
                  placeholder="Nom du produit"
                  value={searchKeyword}
                  style={{
                    border: "1px solid #000000",
                  }}
                  onChange={(e) => setSearchKeyword(e.target.value)}
                />
              </FormGroup>
            </Form>
          </Col>
        </Row>
        <br />
        <Row>
          <Col className='o-auto'>
            <Table style={{ backgroundColor: "white" }}>
              <thead>
                <tr>
                  <th>Produits</th>
                  <th>DCI</th>
                  <th>Forme</th>
                  <th>Action</th>
                </tr>
              </thead>
              {products && filtredList.map((p) => {
                return (
                  <tbody key={filtredList.indexOf(p)}>
                    <tr>
                      <td>{p.product_name}</td>
                      <td>{p.product_dci}</td>
                      <td>{p.product_form}</td>
                      <td style={{ textAlign: "center" }}>
                        <Link to={{
                          pathname: `/product/edit/${p.product_id}`,
                        }}
                          state={{
                            product: p,
                          }}
                        >
                          <i className="fa fa-edit" id="TooltipExample"></i>
                        </Link>
                      </td>
                    </tr>
                  </tbody>
                )
              })
              }
            </Table>
          </Col>
        </Row>
      </Container>
    </Fragment>
  )
}
